import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "../components/PolicyLayout";

const SECTIONS = [
  { id: "general",         label: "General Policy"   },
  { id: "eligible",        label: "Eligible Returns" },
  { id: "non-returnable",  label: "Non-Returnable"   },
  { id: "claims",          label: "Submit a Claim"   },
  { id: "resolutions",     label: "Resolutions"      },
  { id: "contact",         label: "Contact"          },
];

export default function ReturnPolicy() {
  return (
    <PolicyLayout
      title="Return Policy"
      description="Khoja Distributions return and refund policy for wholesale orders. Learn what qualifies for a return and how to submit a claim."
      canonical="https://www.khojadistributions.com/return"
      sections={SECTIONS}
      relatedLinks={
        <Link to="/support" className="text-sm text-accent font-bold hover:underline">
          ← Submit a support request
        </Link>
      }
    >
      <PolicySection id="general" title="General Policy">
        <p>All sales through Khoja Distributions are considered <strong>final</strong> unless the product is received in a damaged, defective, or incorrect condition. We take quality seriously and will work with you to resolve any legitimate issue with your order.</p>
        <p>Because many of our products are consumable, age-restricted, or regulated goods, we cannot accept returns on opened or previously delivered products outside of the conditions described below.</p>
      </PolicySection>

      <PolicySection id="eligible" title="Eligible Return Conditions">
        <p>A return or replacement may be approved under the following circumstances:</p>
        <ul className="space-y-1.5 pl-4 list-disc marker:text-accent">
          <li>Products arrived visibly damaged or broken at the time of delivery</li>
          <li>Wrong products were delivered (item does not match what was ordered)</li>
          <li>Items were missing from the delivered order</li>
          <li>Products are defective and have not been opened or used</li>
        </ul>
        <p>All eligible claims must be reported within <strong>48 hours of delivery</strong>. Claims submitted after this window may not be accepted.</p>
      </PolicySection>

      <PolicySection id="non-returnable" title="Non-Returnable Items">
        <p>The following items are <strong>not eligible</strong> for return under any circumstances:</p>
        <ul className="space-y-1.5 pl-4 list-disc marker:text-accent">
          <li>Opened, used, or tampered tobacco or vaping products</li>
          <li>Kratom, delta, or other consumable products once delivered</li>
          <li>Products damaged after delivery due to improper storage or handling</li>
          <li>Items returned without prior approval from Khoja Distributions</li>
          <li>Products purchased under a clearance or final-sale designation</li>
        </ul>
      </PolicySection>

      <PolicySection id="claims" title="How to Submit a Claim">
        <p>To initiate a return or replacement request, contact us within 48 hours of your delivery:</p>
        <ul className="space-y-1.5 pl-4 list-disc marker:text-accent">
          <li>Call or text: <a href="tel:2146356340" className="text-accent hover:underline">(214) 635-6340</a></li>
          <li>Email: <a href="mailto:khojadistributions@gmail.com" className="text-accent hover:underline">khojadistributions@gmail.com</a></li>
          <li>Or submit a request through our <Link to="/support" className="text-accent hover:underline">Support page</Link></li>
        </ul>
        <p>Please include your order details, a description of the issue, and <strong>clear photos</strong> of the affected products and packaging. Claims without supporting photos may not be approved.</p>
      </PolicySection>

      <PolicySection id="resolutions" title="Resolutions">
        <p>Approved claims will be resolved through one or more of the following at our discretion:</p>
        <ul className="space-y-1.5 pl-4 list-disc marker:text-accent">
          <li>Replacement of the affected items on your next delivery</li>
          <li>Credit applied to your wholesale account</li>
          <li>Partial or full refund for the affected portion of the order</li>
        </ul>
        <p>Refunds, if approved, will be processed within <strong>5–7 business days</strong> using the original payment method.</p>
      </PolicySection>

      <PolicySection id="contact" title="Contact Us">
        <p>
          <strong>Khoja Distributions</strong><br />
          Phone: <a href="tel:2146356340" className="text-accent hover:underline">(214) 635-6340</a><br />
          Email: <a href="mailto:khojadistributions@gmail.com" className="text-accent hover:underline">khojadistributions@gmail.com</a><br />
          Hours: Monday–Saturday, 10am–6pm
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
